import type { AnalyticsProvider } from '../types'
import { analyticsConfig } from '../config'

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void
    _fbq?: unknown
  }
}

class MetaPixelProvider implements AnalyticsProvider {
  init(): void {
    // 스크립트는 index.html에서 이미 로드됨, 검증만 수행
    if (!window.fbq) {
      if (analyticsConfig.debug) {
        console.warn('[Meta Pixel] Not available - fbq not found')
      }
      return
    }

    if (!analyticsConfig.meta.pixelId) {
      if (analyticsConfig.debug) {
        console.warn('[Meta Pixel] Pixel ID not configured')
      }
      return
    }

    if (analyticsConfig.debug) {
      console.log('[Meta Pixel] Ready with ID:', analyticsConfig.meta.pixelId)
    }
  }

  trackPageView(path: string, title?: string): void {
    if (!window.fbq) return

    window.fbq('track', 'PageView', {
      page_path: path,
      page_title: title || document.title,
    })

    if (analyticsConfig.debug) {
      console.log('[Meta Pixel Debug] Page View:', { path, title })
    }
  }

  trackEvent(eventName: string, parameters?: Record<string, unknown>): void {
    if (!window.fbq) return

    // Meta Pixel 표준 이벤트로 매핑
    const metaEventMap: Record<string, string> = {
      sign_up: 'CompleteRegistration',
      login: 'Contact',
      view_item: 'ViewContent',
      add_to_cart: 'AddToCart',
      begin_checkout: 'InitiateCheckout',
      purchase: 'Purchase',
      search: 'Search',
    }

    const metaEventName = metaEventMap[eventName] || eventName

    window.fbq('track', metaEventName, parameters)

    if (analyticsConfig.debug) {
      console.log('[Meta Pixel Debug] Event:', metaEventName, parameters)
    }
  }

  setUserId(userId: string | null): void {
    if (!window.fbq) return

    // Meta Pixel은 setUserProperties를 통해 external_id 업데이트
    // init을 다시 호출하면 중복 경고 발생
    if (userId) {
      this.setUserProperties({ external_id: userId })
    }

    if (analyticsConfig.debug) {
      console.log('[Meta Pixel Debug] User ID:', userId)
    }
  }

  setUserProperties(properties: Record<string, unknown>): void {
    if (!window.fbq) return

    // Meta Pixel은 Advanced Matching을 통해 사용자 정보 전달
    window.fbq('init', analyticsConfig.meta.pixelId, properties)

    if (analyticsConfig.debug) {
      console.log('[Meta Pixel Debug] User Properties:', properties)
    }
  }
}

export const metaPixelProvider = new MetaPixelProvider()
